export const TURNSTILE_SITE_KEY = "0x4AAAAAAEjFTsnpYnW949a-";
export const TURNSTILE_ACTION = "turnstile-spin-v1";
